<template>
  <div class="path-select">
    <Spin overlay v-if="loading" size="mini" />
    <Tree
      :data="treeData"
      ref="tree"
      :selectedKeys.sync="selectedKeys"
      :expandedKeys.sync="expandedKeys"
    >
      <template slot="label" slot-scope="data, node">
        <i
          class="icon ion-ios-folder-outline"
          style="vertical-align: text-bottom;"
        ></i>
        <span
          @click="nodeClicked(node)"
          class="k-text lable-width"
          style=" display:inline-block;    width: calc(100% - 35px);"
          >{{ data.label }}</span
        >
      </template>
    </Tree>
  </div>
</template>

<script>
// import Button from 'kpc/components/button';
import Spin from 'kpc/components/spin';
import { makePathTree } from '@/services/utils';
import Tree from 'kpc/components/tree';
export default {
  name: 'pathSelect',
  props: {
    msg: String,
    tree: {
      type: Array,
      default: function() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  components: {
    // Button,
    Tree,
    Spin
  },
  methods: {
    filterTree() {},
    nodeClicked(node) {
      this.selectedKeys = [node.key];
      // console.log(node)
      // let res = []
      // while(node) {
      //   res.unshift(node.key)
      //   node = node.parent
      // }
      // // 删除最顶层的数字节点
      // res.shift()
      // console.log(res)
      console.log(11111);
      this.$emit('path-selected', node.key);
    }
  },
  computed: {
    treeData() {
      return makePathTree(this.tree);
    }
  },
  data() {
    return {
      expandedKeys: [],
      selectedKeys: []
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
.path-select
  position relative;
  min-height 40px;
  min-width:100px
  max-height: 500px;
  overflow: auto;
  // background yellow;
// .k-tree {
//   // background green
// }
// .k-tree:hover {
//   // background green
// }
.k-node .k-expanded .k-tree:hover{
  // background green
}
.path-select .k-tree .k-label {
  width: 100%;
}
.path-select .k-node .k-expanded > .k-label {
  width: 100%;
}
.k-tree .k-node.k-selected > .k-label .k-text {
  background none
}
// .k-node .k-tree {
//    background none
// }
// .k-tree .k-node .k-expanded:hover
//   background none
// .k-tree .k-tree {
//   background none
// }
// .k-node .k-tree .k-selected:hover {
//    background none
// }
// .k-node .k-tree:hover {
//    background none
// }

.path-select .k-node  .k-selected {
  background none !important
}
.path-select .k-tree .k-node .k-node:hover {
  background none !important
}
// k-node k-expanded k-selected
</style>
